<template>
  <div class="!px-6">
    <h2 class="text-center pt-2 mb-5 mt-4">
      {{ faqHeading }}
    </h2>

    <div class="faq-container border rounded-4xl">
      <AccordionGroup class="px-8" divider="thin">
        <Accordion v-for="(faq, index) in faqs" :key="index">
          <template #title>
            {{ faq.question }}
          </template>
          <template #content><span class="renderedMarkdown" v-html="faq.answer" /> </template>
        </Accordion>
      </AccordionGroup>
      <div class="px-8 pb-8" v-if="displayHelpCenter">
        <Button as="link" href="/help" target="_blank" variant="secondary">
          {{ I18n.t("pricing.visit_help_center") }}
          <template #end>
            <OpenInNewIcon />
          </template>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { FAQ } from "./types";
import { Accordion, Button, OpenInNewIcon, AccordionGroup } from "prism";

withDefaults(
  defineProps<{
    faqHeading: string;
    faqs: FAQ[];
    displayHelpCenter: boolean;
  }>(),
  {
    displayHelpCenter: true,
  }
);

const I18n = inject("I18n");
</script>

<style scoped>
.faq-container {
  max-width: 48rem;
  margin: 0 auto;
}
</style>
